import React, { Component } from "react";
import { connect } from "react-redux";
import { translate } from "react-multi-lang";
import store from "../../store";
import { Resendotp, Login, set_OTP } from "../../actions/accountAction";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import Validation from "../hoc/Validation";
import ReactGA from 'react-ga4';
import { getLocalizedPath } from "../../helpers/languagePath";
class MobileSignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      basePath: window.location.protocol + "//" + window.location.host,
      mobile: "",
      otp: "",
      deviceId: '',
      submitted: false,
    };
  }

  componentWillUnmount() {
    store.dispatch(set_OTP(false));
  }

  componentDidMount() {
    document.title = this.props.t("login.login_otp", { param: "react" });
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    if (!this.state.deviceId) {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      this.setState({ deviceId: result.visitorId })
    }
    const { mobile, otp, deviceId } = this.state;
    if (
      !this.state.submitted &&
      mobile &&
      otp &&
      this.props.validator.fieldValid("number") &&
      this.props.validator.fieldValid("otp")
    ) {
      store.dispatch(
        Login({
          mobile,
          otp,
          device_type: "web",
          device_token: deviceId
        })
      );
      this.setState({ submitted: true });
    } else if (
      mobile &&
      !this.state.submitted &&
      this.props.validator.fieldValid("number") &&
      !this.props.validator.fieldValid("otp") &&
      !otp
    ) {
      await store.dispatch(Resendotp({ mobile }));
      this.setState({ submitted: true });
    } else {
      this.props.validator.showMessages();
      this.forceUpdate();
    }
  };

  resendOtp() {
    const user = {
      mobile: this.state.mobile,
    };
    store.dispatch(Resendotp(user));
  }

  change = (id, e) => {
    let inputType = document.getElementById(id).type;
    if (inputType === "password") {
      document.getElementById(id).type = "text";
      e.target.className = e.target.className.substring(
        0,
        e.target.className.lastIndexOf("-")
      );
    } else {
      document.getElementById(id).type = "password";
      e.target.className += "-slash";
    }
  };

  handleUserInput(e) {
    const name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value, submitted: false });
  }

  redirectConditionally = () => {
    if (
      this.props.actionReducer.link &&
      this.props.actionReducer.Loginuser.user_type === "1"
    ) {
      window.location.href =
        this.state.basePath + getLocalizedPath(this.props.actionReducer.link);
      return;
    }

    if (
      this.props.actionReducer.Loginuser &&
      this.props.actionReducer.Loginuser.user_type &&
      (this.props.actionReducer.Loginuser.user_type === "7" ||
        this.props.actionReducer.Loginuser.user_type === "10" ||
        this.props.actionReducer.Loginuser.user_type === "12")
    ) {
      window.location.href = this.state.basePath + getLocalizedPath("myprofile");
      return;
    }

    if (
      localStorage.getItem("Islogin") &&
      localStorage.getItem("Islogin") === "true"
    ) {
      window.location.href = this.state.basePath + getLocalizedPath("myaccount");
    }
  };

  render() {
    this.redirectConditionally();
    const { validator } = this.props;

    return (
      <section className="login-form main-content-height item-center">
        <div className="container">
          <div className="col-md-12 col-lg-6 mx-auto cover cover-shadow border-0  p-0">
            <div className="first-click-inst p-3">
              <h1 className="fs20px">{this.props.t('login.login_otp', { param: 'react' })}</h1>
            </div>

            <div className="panel-body">
              <form className="col-md-12 mx-auto" onSubmit={this.handleSubmit}>
                <div className="form-group">
                  <div className="row">
                    <div className="col-sm-12 mt-3 ">
                      <label>
                        {this.props.t("login.forgotpass_inst1", {
                          param: "react",
                        })}
                      </label>
                      <input
                        type="number"
                        onChange={(event) => this.handleUserInput(event)}
                        defaultValue={this.state.mobile}
                        placeholder={this.props.t("forms.enterMobile", {
                          param: "react",
                        })}
                        disabled={this.props.notificationReducer.openotp}
                        onBlur={() =>
                          this.props.validator.showMessageFor("number")
                        }
                        className="form-control"
                        id="username"
                        name="mobile"
                        aria-label="Enter mobile"
                        maxLength="10"
                        aria-required="true"
                        autoComplete="tel"
                      />
                      {validator.message(
                        "number",
                        this.state.mobile,
                        "required|phone|numeric|max:10"
                      )}
                    </div>
                  </div>
                </div>
                {this.props.notificationReducer.openotp && (
                  <div className="form-group">
                    <div className="row">
                      <div className="col-sm-12 position-relative">
                        <label>
                          {this.props.t("login.code", { param: "react" })}
                        </label>
                        <input
                          onChange={(event) => this.handleUserInput(event)}
                          placeholder={this.props.t("forms.enterOtp", {
                            param: "react",
                          })}
                          type="number"
                          className="form-control form-eye"
                          id="password-otp"
                          name="otp"
                          defaultValue={this.state.otp}
                          maxLength="6"
                          aria-label="Enter OTP"
                          autoComplete="one-time-code"
                        />
                        {/* {validator.message("otp", this.state.otp, "required")} */}
                        {validator.message("otp", this.state.otp, "required|numeric|max:6")}

                        <span role="button" tabIndex="0"
                          onClick={(e) => this.change("password-otp", e)}
                          className="input fa fa-fw field-icon toggle-password fa-eye-slash"
                        ></span>

                        {/* <button
                          type="submit"
                          disabled={
                            !this.state.otp ||
                            !this.props.validator.fieldValid("otp")
                          }
                          className="btn btn-primary btn-primary2 me-2 my-3"
                        >
                          Login
                        </button>
                        <span
                          style={{ cursor: "pointer" }}
                          className="date-clr mt-4 float-left mr-3"
                        >
                          {this.props.t("login.resend_otp", { param: "react" })}
                        </span> */}

                        <button
                          aria-label='Login with OTP'
                          type="submit"
                          onClick={() => {
                            ReactGA.event({
                              category: 'Auth',
                              action: 'OTP Login',
                              label: 'Login with OTP'
                            });
                          }}
                          disabled={
                            !this.state.otp ||
                            !this.props.validator.fieldValid("otp")
                          }
                          className="btn btn-primary btn-primary2 me-2 my-3"
                        >
                          {this.props.t("login.login", { param: "react" })}
                        </button>

                        <span
                          style={{ cursor: "pointer" }}
                          className="date-clr mt-4 float-left mr-3 fontsml"
                          onClick={this.resendOtp.bind(this)}
                        >
                          {this.props.t("login.resend_otp", { param: "react" })}
                        </span>
                      </div>
                    </div>
                  </div>
                )}

                {!this.props.notificationReducer.openotp && (
                  <div className="form-group">
                    <div className="col-sm-12 p-0">
                      <button
                        type="submit"
                        className="btn btn-primary btn-primary2"
                        onClick={() => {
                          ReactGA.event({
                            category: 'Auth',
                            action: 'GET OTP Submit',
                            label: 'GET OTP Button'
                          });
                        }}
                        aria-label={undefined} // Removed to avoid redundancy
                      >
                        {this.props.t("login.get_OTP", { param: "react" })}
                      </button>

                    </div>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (store) => {
  return store;
};

export default connect(mapStateToProps)(translate(Validation(MobileSignIn)));
